import { useDropzone } from 'react-dropzone';
import classNames from 'classnames';
import React from 'react';
import { startToast } from '../../commons/components/toast/toastDucks';
import { useAppDispatch } from '../../commons/store/hooks';

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 Mo

export const RepairCostFileDropzone = ({
  label,
  file,
  onDrop,
  onRemove,
}: {
  label: string;
  file: File | null;
  onDrop: (files: File[]) => void;
  onRemove: () => void;
}) => {
  const dispatch = useAppDispatch();

  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    onDrop: (acceptedFiles: File[], fileRejections) => {
      if (fileRejections && fileRejections.length > 0) {
        fileRejections.forEach((file) => {
          file.errors.forEach((err) => {
            dispatch(
              startToast({
                text:
                  err.code === 'file-too-large'
                    ? 'La taille du fichier a dépassé la limite maximale de 5 Mo.'
                    : 'Une erreur a survenu lors du téléchargement de ce file: ' + err.message,
                className: 'error',
              }),
            );
          });
        });
        return;
      }
      onDrop(acceptedFiles);
    },
    accept: {
      'application/pdf': ['.pdf'],
      'image/*': [],
    },
    maxSize: MAX_FILE_SIZE,
    multiple: false,
  });

  if (file) {
    return (
      <div className="repair-cost-file-row">
        <span className="file-name">{file.name}</span>
        <span
          className="btn btn-icon remove"
          onClick={(e) => {
            e.preventDefault();
            onRemove();
          }}
        />
      </div>
    );
  }

  return (
    <div
      {...getRootProps()}
      className={classNames('drop-zone drop-zone-small', {
        reject: isDragReject,
        accept: isDragAccept,
        active: isDragActive,
      })}
    >
      <input {...getInputProps()} />
      {isDragActive ? (
        <span>Déposer {label} ici</span>
      ) : (
        <span>
          {label} — PDF ou image (max 5 Mo)
          <br />
          Déposez le fichier ici,
          <br />
          ou cliquez pour sélectionner le fichier à ajouter
        </span>
      )}
    </div>
  );
};
